// useKeyboardOpen — открыта ли экранная клавиатура в мобильном приложении.
//
// Источник — атрибут `data-keyboard-open` на <html>, который ставит
// `apps/mobile/src/init-keyboard.ts` по событиям плагина Keyboard. Своей
// подписки на плагин здесь нет: признак уже живёт в одном месте, и второй
// слушатель разъехался бы с ним.
//
// В браузере (desktop / mobile web) атрибут не появляется никогда, поэтому хук
// всегда отдаёт `false`. Это намеренно: в Safari и Chrome клавиатура не сжимает
// layout viewport, нижнее меню остаётся под ней и места не отнимает. В
// приложении (`Keyboard.resize = native`) WebView сжимается, и всё, что
// прижато к низу, встаёт прямо над клавиатурой — там и нужна реакция.

import { useSyncExternalStore } from "react";

function readKeyboardOpen(): boolean {
	return document.documentElement.dataset.keyboardOpen === "true";
}

function subscribe(onChange: () => void): () => void {
	const observer = new MutationObserver(onChange);
	observer.observe(document.documentElement, {
		attributes: true,
		attributeFilter: ["data-keyboard-open"],
	});
	return () => observer.disconnect();
}

export function useKeyboardOpen(): boolean {
	return useSyncExternalStore(subscribe, readKeyboardOpen, () => false);
}
